
import { useState, useEffect } from "react";
import { Shop } from "@/components/dashboard/shops/types";
import { getCurrentUserOrganizationId } from "@/lib/supabase/products/organization";

export const useFormState = (shop: Shop) => {
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [isSaving, setIsSaving] = useState<boolean>(false);
  
  // Form properties
  const [ctaButtonText, setCtaButtonText] = useState<string>(shop.cta_button_text || "Acheter maintenant");
  const [formName, setFormName] = useState<string>(shop.form_name || "Formulaire de contact");
  const [formProductIds, setFormProductIds] = useState<string[]>(shop.form_product_ids || []);
  
  // New form fields state
  const [phone, setPhone] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [email, setEmail] = useState("");
  const [country, setCountry] = useState("");
  const [region, setRegion] = useState("");
  const [municipality, setMunicipality] = useState("");
  const [address, setAddress] = useState("");
  const [externalId, setExternalId] = useState("");
  
  // Form associations
  const [formOrganizationId, setFormOrganizationId] = useState<string | undefined>(shop.form_organization_id);
  const [formShopId, setFormShopId] = useState<string | undefined>(shop.form_shop_id);
  
  // Load organization ID if not defined
  useEffect(() => {
    const loadOrganizationId = async () => {
      if (!formOrganizationId) {
        const orgId = await getCurrentUserOrganizationId();
        if (orgId) {
          setFormOrganizationId(orgId);
        }
      }
    };
    
    loadOrganizationId();
  }, [formOrganizationId]);
  
  // Set shop_id automatically if not defined
  useEffect(() => {
    if (!formShopId && shop.id) {
      setFormShopId(shop.id);
    }
  }, [formShopId, shop.id]);

  return {
    isEditing,
    setIsEditing,
    isSaving,
    setIsSaving,
    ctaButtonText,
    setCtaButtonText,
    formName,
    setFormName,
    formProductIds,
    setFormProductIds,
    formOrganizationId,
    setFormOrganizationId,
    formShopId,
    setFormShopId,
    
    // Customer info fields
    phone,
    setPhone,
    customerName,
    setCustomerName,
    email,
    setEmail,
    country,
    setCountry,
    region,
    setRegion,
    municipality,
    setMunicipality,
    address,
    setAddress,
    externalId,
    setExternalId
  };
};
